import { ServicerType } from '../enums/common/servicer-type';
import { SumamoruProjectType } from '../enums/common/sumamoru-project-type';

export const region = 'ap-northeast-1';
export const stage = 'develop';
export const bkpPath = 'https://edge.bitkey.tokyo/v1';
export const ifBasePath = 'https://develop.api.cde.og.bitlock.xyz/link/api/v1/';
// 一時的にstgに向ける
export const bmResidence = 'https://us-central1-bitlock-staging.cloudfunctions.net/ext-vo/';
export const searchApiBasePath = 'https://api.staging-homehub.site/';

export const getProjectId = (type: SumamoruProjectType): string => {
  switch (type) {
    case 'CDE':
      return '48566ff5-3e7c-4c1f-ac2f-73cef2009f64';
  }
  throw new Error(`there is no type: ${type}`);
};

export const getProjectType = (id: string): SumamoruProjectType => {
  const key = Object.values(SumamoruProjectType).find(key => {
    try {
      return getProjectId(key) == id;
    } catch (e) {
      return false;
    }
  });
  if (!key) {
    throw new Error(`there is no id: ${id}`);
  }
  return key;
};

export const defaultProjectId = getProjectId(SumamoruProjectType.CDE);
export const sumamoruProjectTypes = [SumamoruProjectType.CDE, SumamoruProjectType.CDEOnlyElectricity];
export const energyServicerType = ServicerType.CDE;
